<template>
  <v-system-bar
    v-if="warningBarInfo"
    app
    height="28"
    color="warning"
  >
    <!-- subscription -->
    <v-icon color="black">
      mdi-alert-octagon
    </v-icon>
    <!--  -->
    <span class="black--text ellipsize">
      {{ $t(warningBarInfo.infoKey, [warningBarInfo.extraText]) }}
    </span>

    <i18n
      :path="warningBarInfo.navKey"
      tag="span"
      class="black--text d-none d-md-inline pl-1"
    >
      <router-link
        to="/settings/billing"
        class="blue--text"
      >
        {{ $t(warningBarInfo.navLinkKey) }}
      </router-link>
    </i18n>
    <!--  -->
    <v-spacer />
    <v-btn
      v-if="warningBarInfo.buttonKey"
      elevation="0"
      depressed
      x-small
      color="black"
      class="white--text"
      to="/settings/billing"
    >
      {{ $t(warningBarInfo.buttonKey) }}
    </v-btn>
  </v-system-bar>
</template>

<script setup lang="ts">
import { WarningBarInfo } from '@/services/billing-utils';
import { PropType, computed } from 'vue';

const props = defineProps({
  subWarningBarInfo: { type: Object as PropType<WarningBarInfo|null>, required: false, default: null },
  smsWarningBarInfo: { type: Object as PropType<WarningBarInfo|null>, required: false, default: null },
  paymentWarningBarInfo: { type: Object as PropType<WarningBarInfo|null>, required: false, default: null },
});

const warningBarInfo = computed(
  () => props.subWarningBarInfo ?? props.paymentWarningBarInfo ?? props.smsWarningBarInfo,
);

</script>
